<template>
  <v-dialog 
    v-model="show" 
    :max-width="width" 
    :persistent="persistent" 
    scrollable 
    :overlay-color="isDark ? 'white' : 'black'"
  >
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip :disabled="!title" bottom transition="none" color="black">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            v-if="mode == 'button'"
            :icon="Boolean(icon)" :tile="tile" depressed :color="color"
            @click="show = true"
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
            :disabled="disabled"
            >
            <v-icon v-if="icon" :color="color">{{icon}}</v-icon>
            <template v-else>
              {{ linkText }}
            </template>
          </v-btn>
          <v-list-item 
            v-if="mode == 'listitem'"
            v-bind="attrs" 
            v-on="{ ...dialog }" 
            @click="show=true"
            :disabled="disabled"
          >
            <v-list-item-icon>
              <v-icon :color="color">{{icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content v-if="linkDescription">
              <v-list-item-title>{{ linkText }}</v-list-item-title>
              <v-list-item-subtitle>{{ linkDescription }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content v-else>{{ linkText }}</v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ tooltip ? tooltip : title }}</span>
      </v-tooltip>
    </template>
    <v-form ref="form" enctype="multipart/form-data" @submit.prevent="onSubmit">
      <v-card :loading="loading" :disabled="loading">
        <template slot="progress">
          <v-progress-linear
            :indeterminate="isEmpty($store.state.socket.progress)"
            :value="$store.state.socket.progress.percentage"
          ></v-progress-linear>
        </template>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-subtitle v-if="subtitle">{{ subtitle }}</v-card-subtitle>
        <slot name="content">
          <v-card-text>Loading...</v-card-text>
        </slot>
        <v-card-actions>
          <slot name="footer_prefix"></slot>
          <v-spacer></v-spacer>
          <v-btn v-if="cancel" text @click="show = false"><slot name="cancel_text">Cancel</slot></v-btn>
          <v-btn text color="success" type="submit" :disabled="!valid"><slot name="submit_text">OK</slot></v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
export default {
  name: "AxDialog",
  props: {
    persistent: { type: Boolean, default: false },
    size: { type: String, default: 'small' },
    title: { type: String, required: true },
    tooltip: { type: String, required: false },
    linkText: { type: String, default: 'Click here' },
    linkDescription: { type: String, default: null },
    subtitle: { type: String, default: null },
    icon: { type: String, default: null },
    color: { type: String, default: undefined },
    tile: { type: Boolean, default: false },
    mode: { type: String, default: 'button' },
    cancel: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      show: false,
      loading: false,
      valid: true
    }
  },
  watch: {
    show: function() {
      this.$emit('shown', this.show)
    }
  },
  computed: {
    width() {
      if (this.size == 'small') return 300
      else if (this.size == 'medium') return 600
      else if (this.size == 'large') return 900
      else return null
    }
  },
  methods: {
    onSubmit() {
      this.$emit("submitted")
    },
  },
}
</script>